import React, { useEffect, useState } from "react";
import * as queries from "../../../utils/prismicQueries";
import "./contact.css";
import SocialLinks from "../../../main/components/socialLinks";
import Footer from "../../../pages/footer/Footer/Footer";
import client from "../../../utils/prismicHelpers";
import PlayBtn from "../../../main/components/PlayBtn";

const ContactSection = () => {
  const [contactInfo, setContactInfo] = useState(null);

  useEffect(() => {
    client
      .query({
        query: queries.contactInfo,
      })
      .then((response) => {
        const contactInfos = response.data.allContacts.edges[0].node;
        setContactInfo(contactInfos);
      })
      .catch((error) => {
        console.error(error);
      });
  });
  // const footerStyle = `
  // @media (min-width: 1400px) {

  //     .footer-main{
  //         height:500px;
  //     }

  // }`

  return (
    <>
      <section
        style={{ background: `url(${contactInfo?.contact_bg?.url})` }}
        className="contact-container "
      >
        <div className="pt-4 container">
          <div className="row">
            <div className="col-md-5 ">
              <h5 className="section-title">      {contactInfo?.title[0]?.text}   </h5>
              <h3 className="subtitle">{contactInfo?.sub_title[0]?.text}</h3>
            </div>
            <div className="col-md-7">
              <div className="contact-right">
                <div className="d-flex  position-relative justify-content-center video-container">
                  <img
                    src={contactInfo?.video_thumbnail?.url}
                    className="img-fluid "
                    alt=""
                  />
                  <div
                    style={{ zIndex: '10' }}
                    className="position-absolute top-50">
                    <PlayBtn link={contactInfo?.video?.embed_url} />
                  </div>

                </div>

                <div className="d-flex  address-content justify-content-center ps-sm-5   justify-content-md-end    p-2  pt-5">
                  <span className=" d-block  pe-2">
                    {" "}
                    <img src={contactInfo?.location_logo?.url} alt="" />
                  </span>

                  <a target="_blank" className="text-decoration-none" href={contactInfo?.location_link}><p className="primary-fnt    ">
                    {contactInfo?.location[0]?.text}
                  </p></a>
                </div>
              </div>
            </div>
          </div>
          <div className="concont">
            <div className="contact-info  p-4">
              <p className="primary-fnt">
                {contactInfo?.card_title[0]?.text}
              </p>
              <div className="d-flex justify-content-between flex-column flex-md-row ">
                <a
                  target="_blank"
                  className="text-decoration-none "
                  href={"mailto:" + contactInfo?.card_email[0]?.text}
                >
                  <h3 className="primary-text contact-email">
                    {contactInfo?.card_email[0]?.text}
                  </h3>
                </a>{" "}
                <a
                  target="_blank"
                  className="text-decoration-none "
                  href={"mailto:" + contactInfo?.card_email2}
                >
                  <h3 className="primary-text contact-email">
                    {contactInfo?.card_email2}
                  </h3>
                </a>{" "}
              </div>
              <hr />
              <a
                target="_blank"
                className="text-decoration-none "
                href={"tel:" + contactInfo?.card_number[0]?.text}>
                <div className="primary-text">
                  <h3 className="primary-text">
                    {contactInfo?.card_number[0]?.text}
                  </h3>
                </div>
              </a>{" "}

            </div>
            <div className="social-links">
              <SocialLinks></SocialLinks>
            </div>
          </div>
        </div>
      </section>
      <div className="footer-main">
        <Footer></Footer>
      </div>
    </>
  );
};

export default ContactSection;
